<template>
    <v-container grid-list-xl class="pt-2" style="min-width: 100%;">
        <v-layout row class="pt-0 pb-1 px-0">
            <div class="headline mt-1 ml-2 mr-3 pl-1">Public Messages</div>
            <v-btn
                small
                color="success"
                class="mr-2 mt-2"
                v-if="!newBroadcast"
                @click="addBroadcast()"
                >Add Message</v-btn
            >
        </v-layout>
        <v-card class="pa-3 mb-3">
            <div v-if="newBroadcast">
                <v-layout row class="mt-1">
                    <v-btn
                        small
                        style="height: 28px"
                        outline
                        class="ml-3 mt-3"
                        :loading="newBroadcast.uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="newBroadcast.files.length" class="mt-3 ml-2">
                        {{ newBroadcast.files[0].name }}
                    </div>
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept="audio/*"
                        @change="onFilePicked($event)"
                    />
                    <v-select
                        v-if="!branch"
                        class="pl-0 pr-3 mb-1 mx-3"
                        style="max-width: 300px"
                        :items="branches"
                        label="Branch"
                        multiple
                        v-model="newBroadcast.branch"
                    ></v-select>
                    <v-menu
                        v-model="newBroadcast.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-calendar"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="mx-3"
                                style="max-width: 200px"
                                v-model="newBroadcast.expires"
                                :value="newBroadcast.expires"
                                label="Expire Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newBroadcast.expires"
                        ></v-date-picker>
                    </v-menu>
                    <div class="mt-3 ml-4">
                        <v-btn
                            class="my-0 pt-2 mr-2"
                            style="height: 28px"
                            @click.stop="cancelNewBroadcast()"
                            small
                            dark
                            color="default"
                            >Cancel
                        </v-btn>
                        <v-btn
                            class="my-0 pt-2 mr-2"
                            style="height: 28px"
                            @click.stop="saveNewBroadcast()"
                            small
                            color="success"
                            >Save
                        </v-btn>
                    </div>
                </v-layout>
                <v-divider class="py-2 mb-1"></v-divider>
            </div>
            <div style="overflow-y: auto; height: 300px; overflow-x: hidden">
                <div v-for="(broadcast, index) in broadcasts">
                    <v-layout
                        row
                        row
                        justify-space-between
                        v-bind:class="{ expired: isExpired(broadcast) }"
                    >
                        <div
                            v-if="broadcast.date"
                            class="font-weight-medium ml-3 mt-3"
                        >
                            Uploaded On:<span class="ml-2 font-weight-light">{{
                                broadcast.date | time
                            }}</span>
                        </div>

                        <audio
                            class="mb-2 mt-1"
                            controls
                            :src="broadcast.recordingURL"
                        ></audio>

                        <div v-if="!branch" class="font-weight-medium mt-3">
                            Branch:<span class="font-weight-light ml-2">
                                {{ broadcast.branch }}
                            </span>
                        </div>

                        <div
                            class="font-weight-medium mt-3 mr-2"
                            v-if="!broadcast.editing"
                        >
                            Expires:<span class="font-weight-light ml-2">{{
                                broadcast.expires | date
                            }}</span>
                            <span
                                v-if="isExpired(broadcast)"
                                style="background-color: red; color: #fff"
                                class="ml-2 px-2"
                                >Expired</span
                            >
                        </div>

                        <v-menu
                            v-if="broadcast.editing"
                            v-model="broadcast.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-calendar"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    style="max-width: 200px"
                                    v-model="broadcast.expires"
                                    :value="broadcast.expires"
                                    label="Expire Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="broadcast.expires"
                            ></v-date-picker>
                        </v-menu>
                        <div v-if="broadcast.editing" class="mt-3">
                            <v-btn
                                class="my-0 pt-2 mr-2"
                                style="height: 28px"
                                @click.stop="cancelEditBroadcast(broadcast)"
                                small
                                dark
                                color="default"
                                >Cancel
                            </v-btn>
                            <v-btn
                                class="my-0 pt-2 mr-2"
                                style="height: 28px"
                                @click.stop="saveBroadcast(broadcast)"
                                small
                                color="success"
                                >Save
                            </v-btn>
                        </div>
                        <div>
                            <v-btn
                                class="my-0 pt-2"
                                v-if="!broadcast.editing"
                                @click.stop="editBroadcast(broadcast)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                class="my-0 pt-2"
                                v-if="!broadcast.editing"
                                @click.stop="openDeleteDialog(broadcast)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-layout>
                    <v-divider
                        class="py-2 mb-1"
                        v-if="index + 1 < broadcasts.length"
                    ></v-divider>
                </div>
            </div>
        </v-card>
        <div class="headline mt-1 mb-2 mr-3">Block List</div>
        <v-card class="mb-3 pa-2 pl-3 pb-3">
            <div v-if="!editingBlockList">
                <v-btn
                    small
                    color="success"
                    class="mt-2 mb-2"
                    @click="editBlockList"
                    >{{
                        blockList.length ? "Edit Block List" : "Add Number"
                    }}</v-btn
                >
                <div
                    style="overflow-y: auto; height: 275px; overflow-x: hidden"
                >
                    <div v-for="(block, index) in blockList">
                        <v-layout row class="pt-3 pb-2 px-3">
                            <div class="width-250">
                                {{ block.number | phone }}
                            </div>
                            <div class="width-250">
                                {{ getBranch(block.branch) }}
                            </div>
                        </v-layout>
                        <v-divider
                            class="mb-2"
                            v-if="index + 1 < blockList.length"
                        ></v-divider>
                    </div>
                </div>
            </div>
            <div v-if="editingBlockList" class="mt-3 pt-3">
                <div
                    style="overflow-y: auto; height: 275px; overflow-x: hidden"
                    class="pt-2"
                >
                    <v-layout
                        row
                        class="px-3"
                        style="width: 500px"
                        v-for="(block, index) in blockList"
                    >
                        <v-text-field
                            class="px-1 mr-2 pt-0 mt-0"
                            label="Number"
                            v-model="block.number"
                            ref="blockListNumber"
                            :disabled="isDisabled(block)"
                            :rules="[rules.phoneNumber]"
                        ></v-text-field>
                        <v-select
                            v-if="!branch"
                            class="px-1 pt-0 mt-0"
                            label="Branch"
                            v-model="block.branch"
                            :items="branches"
                            ref="blockListBranch"
                            style="max-width: 200px"
                            :rules="[rules.required]"
                            multiple
                        ></v-select>
                        <v-btn
                            class="pt-0 mt-0"
                            @click="addNumber"
                            flat
                            icon
                            color="success"
                        >
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            class="pt-0 mt-0"
                            @click="removeNumber(index)"
                            :disabled="isDisabled(block)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </div>
                <div style="width: 458px;">
                    <v-card-actions class="mr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            small
                            color="default"
                            dark
                            @click="rollbackBlocklist"
                            >Cancel</v-btn
                        >
                        <v-btn
                            small
                            :loading="processing"
                            color="success"
                            @click="saveBlockList"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </div>
            </div>
        </v-card>
        <div class="headline mt-1 mb-2 mr-3">Phone Disable Schedule</div>
        <v-card class="pa-2 pl-3 pb-3">
            <div v-if="!editingSchedule">
                <v-btn
                    small
                    color="success"
                    class="mt-2 mb-2"
                    @click="editSchedule"
                    >{{
                        phoneSchedules.length ? "Edit Schedule" : "Add Schedule"
                    }}</v-btn
                >
                <div
                    style="overflow-y: auto; height: 275px; overflow-x: hidden"
                >
                    <div v-for="(schedule, index) in phoneSchedules">
                        <v-layout
                            row
                            class="pt-3 pb-2 px-3"
                            justify-space-between
                            v-bind:class="{ expired: !schedule.isEnabled }"
                        >
                            <div
                                v-if="schedule.days"
                                class="font-weight-medium width-300"
                            >
                                Days:<span class="ml-2 font-weight-light">{{
                                    schedule.days
                                }}</span>
                            </div>
                            <div
                                v-if="schedule.timeFrom"
                                class="font-weight-medium width-200"
                            >
                                From:<span class="ml-2 font-weight-light">{{
                                    schedule.timeFrom
                                }}</span>
                            </div>
                            <div
                                v-if="schedule.timeTo"
                                class="font-weight-medium width-200"
                            >
                                To:<span class="ml-2 font-weight-light">{{
                                    schedule.timeTo
                                }}</span>
                            </div>
                            <div
                                v-if="schedule.branch"
                                class="font-weight-medium width-250"
                            >
                                Branch:<span class="ml-2 font-weight-light">{{
                                    getBranch(schedule.branch)
                                }}</span>
                            </div>
                            <div
                                v-if="!schedule.isEnabled"
                                class="ml-3 px-2"
                                style="background-color: red; color: #fff"
                            >
                                Disabled
                            </div>
                        </v-layout>
                        <v-divider
                            class="mb-2"
                            v-if="index + 1 < phoneSchedules.length"
                        ></v-divider>
                    </div>
                </div>
            </div>
            <div v-if="editingSchedule" class="mt-3 pt-3">
                <div
                    class="pt-2"
                    style="overflow-y: auto; height: 275px; overflow-x: hidden"
                >
                    <v-layout
                        row
                        class="px-3"
                        v-for="(schedule, index) in phoneSchedules"
                    >
                        <v-checkbox
                            color="success"
                            v-model="schedule.isEnabled"
                            label="Enabled"
                            style="max-width: 115px"
                        >
                        </v-checkbox>
                        <v-select
                            class="pr-1 pt-0 mt-0"
                            label="Days"
                            :disabled="isDisabled(schedule)"
                            v-model="schedule.daysSelected"
                            :items="daysList"
                            ref="scheduleDays"
                            style="max-width: 300px"
                            :rules="[rules.required]"
                            multiple
                        ></v-select>
                        <v-menu
                            ref="timeFrom"
                            v-model="schedule.timePickerMenu"
                            :close-on-content-click="false"
                            :return-value.sync="schedule.timeFrom"
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.timeFrom"
                                    :disabled="isDisabled(schedule)"
                                    label="Time From"
                                    class="pr-1 pt-0 mt-0"
                                    readonly
                                    style="width: 250px"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                width="290"
                                v-if="schedule.timePickerMenu"
                                v-model="schedule.timeFrom"
                                @input="saveTimeFrom(schedule, $event, index)"
                            ></v-time-picker>
                        </v-menu>
                        <v-menu
                            ref="timeTo"
                            v-model="schedule.timePickerToMenu"
                            :close-on-content-click="false"
                            :return-value.sync="schedule.timeTo"
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.timeTo"
                                    :disabled="isDisabled(schedule)"
                                    label="Time To"
                                    class="pr-1 pt-0 mt-0"
                                    readonly
                                    style="width: 250px"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                width="290"
                                v-if="schedule.timePickerToMenu"
                                v-model="schedule.timeTo"
                                @input="saveTimeTo(schedule, $event, index)"
                            ></v-time-picker>
                        </v-menu>
                        <v-select
                            v-if="!branch"
                            class="px-1 pt-0 mt-0"
                            label="Branch"
                            v-model="schedule.branch"
                            :items="branches"
                            ref="scheduleBranch"
                            style="max-width: 200px"
                            :rules="[rules.required]"
                            multiple
                        ></v-select>
                        <v-btn
                            class="pt-0 mt-0"
                            @click="addSchedule"
                            flat
                            icon
                            color="success"
                        >
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            class="pt-0 mt-0"
                            @click="removeSchedule(index)"
                            :disabled="isDisabled(schedule)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </div>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        color="default"
                        dark
                        @click="rollbackPhoneSchedules"
                        >Cancel</v-btn
                    >
                    <v-btn
                        small
                        :loading="processing"
                        color="success"
                        @click="savePhoneSchedules"
                        >Save</v-btn
                    >
                </v-card-actions>
            </div>
        </v-card>
        <v-dialog v-model="deleteBroadcastDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline pb-2"
                    >Are You Sure?</v-card-title
                >
                <div class="mx-3 mb-3">This will delete the message</div>
                <v-card-actions class="mx-0 px-2 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteBroadcastDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteBroadcast"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";

export default {
    data() {
        return {
            broadcasts: [],
            blockList: [],
            phoneSchedules: [],
            processing: false,
            deleteBroadcastDialog: false,
            editingBlockList: false,
            editingSchedule: false,
            broadcastToDelete: "",
            today: new Date().toISOString().substr(0, 10),

            rules: {
                required: (value) => !!value || "Required.",

                phoneNumber: (v) => {
                    return (
                        !v ||
                        ([10, 11].includes(v.replace(/-/g, "").length) &&
                            /^\d+$/.test(v.replace(/-/g, ""))) ||
                        "Invalid Phone Number"
                    );
                },
            },

            branches: [],

            branch: "",
            newBroadcast: null,

            blockListToDelete: [],
            scheduleToDelete: [],
            daysList: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],

            times: [
                { value: "00:00", text: "12:00 AM" },
                { value: "00:30", text: "12:30 AM" },
                { value: "01:00", text: "01:00 AM" },
                { value: "01:30", text: "01:30 AM" },
                { value: "02:00", text: "02:00 AM" },
                { value: "02:30", text: "02:30 AM" },
                { value: "03:00", text: "03:00 AM" },
                { value: "03:30", text: "03:30 AM" },
                { value: "04:00", text: "04:00 AM" },
                { value: "04:30", text: "04:30 AM" },
                { value: "05:00", text: "05:00 AM" },
                { value: "05:30", text: "05:30 AM" },
                { value: "06:00", text: "06:00 AM" },
                { value: "06:30", text: "06:30 AM" },
                { value: "07:00", text: "07:00 AM" },
                { value: "07:30", text: "07:30 AM" },
                { value: "08:00", text: "08:00 AM" },
                { value: "08:30", text: "08:30 AM" },
                { value: "09:00", text: "09:00 AM" },
                { value: "09:30", text: "09:30 AM" },
                { value: "10:00", text: "10:00 AM" },
                { value: "10:30", text: "10:30 AM" },
                { value: "11:00", text: "11:00 AM" },
                { value: "11:30", text: "11:30 AM" },
                { value: "12:00", text: "12:00 PM" },
                { value: "12:30", text: "12:30 PM" },
                { value: "13:00", text: "01:00 PM" },
                { value: "13:30", text: "01:30 PM" },
                { value: "14:00", text: "02:00 PM" },
                { value: "14:30", text: "02:30 PM" },
                { value: "15:00", text: "03:00 PM" },
                { value: "15:30", text: "03:30 PM" },
                { value: "16:00", text: "04:00 PM" },
                { value: "16:30", text: "04:30 PM" },
                { value: "17:00", text: "05:00 PM" },
                { value: "17:30", text: "05:30 PM" },
                { value: "18:00", text: "06:00 PM" },
                { value: "18:30", text: "06:30 PM" },
                { value: "19:00", text: "07:00 PM" },
                { value: "19:30", text: "07:30 PM" },
                { value: "20:00", text: "08:00 PM" },
                { value: "20:30", text: "08:30 PM" },
                { value: "21:00", text: "09:00 PM" },
                { value: "21:30", text: "09:30 PM" },
                { value: "22:00", text: "10:00 PM" },
                { value: "22:30", text: "10:30 PM" },
                { value: "23:00", text: "11:00 PM" },
                { value: "23:30", text: "11:30 PM" },
            ],
        };
    },
    async created() {
        await this.loadBranches();

        this.branch = this.$store.state.authentication.branch;
        this.branch = this.branch == "null" ? null : this.branch;

        await this.loadBroadcasts();
        await this.loadBlockList();
        await this.loadPhoneSchedules();
    },
    computed: {},
    methods: {
        async loadBroadcasts() {
            let broadcasts = await this.$http.get(
                "api/campCalls/getBroadcasts?" +
                    (this.branch ? "branch=" + this.branch : ""),
            );

            broadcasts = broadcasts.map((broadcast) => {
                broadcast.editing = false;
                broadcast.datePickerMenu = false;
                broadcast.expires = toISOLocal(
                    new Date(broadcast.expires),
                ).substr(0, 10);

                return broadcast;
            });

            const active = broadcasts.filter((b) => !this.isExpired(b));
            const inactive = broadcasts.filter((b) => this.isExpired(b));

            this.broadcasts = active;

            inactive.forEach((b) => this.broadcasts.push(b));
        },
        async loadBranches() {
            const branches = await this.$http.get(
                "api/campStudents/getBranches",
            );

            this.branches = branches;
        },
        async loadBlockList() {
            const blockList = await this.$http.get(
                "api/campCalls/getBlockList?" +
                    (this.branch ? "branch=" + this.branch : ""),
            );

            this.blockList = blockList;
        },
        async loadPhoneSchedules() {
            const phoneSchedules = await this.$http.get(
                "api/campCalls/getPhoneSchedules?" +
                    (this.branch ? "branch=" + this.branch : ""),
            );

            this.phoneSchedules = phoneSchedules.map((schedule) => {
                schedule.timePickerMenu = false;
                schedule.timePickerToMenu = false;
                schedule.daysSelected = this.getDaysForNumber(
                    schedule.days,
                ).split(",");
                schedule.days = this.getDaysForNumber(schedule.days);

                return schedule;
            });
        },
        isEmpty(str) {
            return !str || str.length === 0;
        },
        isDisabled(schedule) {
            return (
                !this.isEmpty(this.branch) &&
                Array.isArray(schedule.branch) &&
                schedule.branch.length > 1
            );
        },
        getTimeText(time) {
            return this.times.find((t) => t.value == time).text;
        },
        saveTimeFrom(schedule, value, index) {
            this.$refs.timeFrom[index].save(value);
        },
        saveTimeTo(schedule, value, index) {
            this.$refs.timeTo[index].save(value);
        },
        editBroadcast(broadcast) {
            broadcast.editing = true;
        },
        cancelEditBroadcast(broadcast) {
            broadcast.editing = false;

            this.loadBroadcasts();
        },
        isExpired(broadcast) {
            return (
                broadcast.expires && new Date(broadcast.expires) < new Date()
            );
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.newBroadcast.files = files;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?convertMp3=true",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.newBroadcast.url = response.url;
                this.newBroadcast.uploading = false;
            } catch (e) {
                this.newBroadcast.uploading = false;
            }
        },
        cancelNewBroadcast() {
            this.newBroadcast = null;
        },
        async saveNewBroadcast() {
            if (!this.newBroadcast.files.length) {
                this.$notify({
                    group: "notification",
                    text: "Please upload file",
                    type: "error",
                });

                return;
            }

            const branch = this.newBroadcast.branch.length
                ? this.newBroadcast.branch.join(",")
                : this.branch;

            if (!branch) {
                this.$notify({
                    group: "notification",
                    text: "Branch Required",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                await this.$http.post(
                    "api/campCalls/uploadBroadcast?branch=" +
                        branch +
                        "&user=" +
                        this.$store.state.authentication.user +
                        "&url=" +
                        this.newBroadcast.url +
                        "&expires=" +
                        this.newBroadcast.expires,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.newBroadcast = null;

                this.loadBroadcasts();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        addBroadcast() {
            this.newBroadcast = {
                datePickerMenu: false,
                branch: "",
                files: [],
                uploading: false,
                expires: "",
            };
        },
        openDeleteDialog(broadcast) {
            this.broadcastToDelete = broadcast;
            this.deleteBroadcastDialog = true;
        },
        async deleteBroadcast() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/campCalls/deleteBroadcast?id=" +
                        this.broadcastToDelete.id,
                );

                this.processing = false;
                this.deleteBroadcastDialog = false;

                this.loadBroadcasts();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveBroadcast(broadcast) {
            this.processing = true;

            try {
                await this.$http.post("api/campCalls/saveBroadcast", broadcast);

                this.processing = false;

                this.loadBroadcasts();
            } catch (e) {
                this.processing = false;
            }
        },
        editBlockList() {
            this.editingBlockList = true;

            this.blockList.forEach((blockList) => {
                blockList.branch = blockList.branch.split(",");
            });

            if (!this.blockList.length) {
                this.addNumber();
            }
        },
        rollbackBlocklist() {
            this.editingBlockList = false;
            this.loadBlockList();
        },
        async saveBlockList() {
            if (
                !this.branch &&
                this.blockList.filter((b) => b.number).some((b) => !b.branch)
            ) {
                this.$notify({
                    text: "Missing Branch",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.$refs.blockListNumber.some((n) => !n.validate(true)))
                return;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            try {
                this.processing = true;

                const list = this.blockList
                    .filter((b) => b.number)
                    .map((block) => {
                        block.number = block.number;
                        block.branch = block.branch
                            ? block.branch.join(",")
                            : this.branch;
                        block.createdBy = this.$store.state.authentication.user;
                        block.createdAt = today;

                        return block;
                    });

                await this.$http.post("api/campCalls/saveBlockList", {
                    toUpdate: list || [],
                    toDelete: this.blockListToDelete.map((block) => {
                        block.branch = block.branch
                            ? block.branch.join(",")
                            : this.branch;

                        return block;
                    }),
                });

                this.processing = false;
                this.editingBlockList = false;
                this.blockListToDelete = [];

                this.loadBlockList();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        addNumber() {
            this.blockList.push({
                number: "",
            });

            this.$forceUpdate();
        },
        removeNumber(index) {
            if (this.blockList.length == 1) {
                this.blockList[index].number == "";

                return;
            }

            this.blockListToDelete.push(this.blockList[index]);

            this.blockList.splice(index, 1);

            this.$forceUpdate();
        },
        getDaysForNumber(days) {
            const weekdays = new Array(7);

            weekdays[0] = "Sunday";
            weekdays[1] = "Monday";
            weekdays[2] = "Tuesday";
            weekdays[3] = "Wednesday";
            weekdays[4] = "Thursday";
            weekdays[5] = "Friday";
            weekdays[6] = "Saturday";

            return days
                .split(",")
                .map((day) => {
                    return weekdays[day - 1];
                })
                .join(",");
        },
        getNumberForDays(days) {
            const weekdays = new Array(7);

            weekdays[0] = "Sunday";
            weekdays[1] = "Monday";
            weekdays[2] = "Tuesday";
            weekdays[3] = "Wednesday";
            weekdays[4] = "Thursday";
            weekdays[5] = "Friday";
            weekdays[6] = "Saturday";

            return days
                .map((day) => {
                    return weekdays.indexOf(day) + 1;
                })
                .join(",");
        },
        editSchedule() {
            this.editingSchedule = true;

            this.phoneSchedules.forEach((schedule) => {
                schedule.branch = schedule.branch.split(",");
            });

            if (!this.phoneSchedules.length) {
                this.addSchedule();
            }
        },
        addSchedule() {
            this.phoneSchedules.push({
                days: "",
                timeFrom: "",
                timeTo: "",
                branch: "",
            });

            this.$forceUpdate();
        },
        removeSchedule(index) {
            // if (this.phoneSchedules.length == 1) {
            //     this.phoneSchedules[index].days == "";
            //     this.phoneSchedules[index].timeFrom == "";
            //     this.phoneSchedules[index].timeTo == "";
            //     this.phoneSchedules[index].branch == "";

            //     return;
            // }

            this.scheduleToDelete.push(this.phoneSchedules[index]);

            this.phoneSchedules.splice(index, 1);

            this.$forceUpdate();
        },
        rollbackPhoneSchedules() {
            this.editingSchedule = false;
            this.loadPhoneSchedules();
        },
        validateSchedules() {
            if (!this.branch && this.phoneSchedules.some((b) => !b.branch)) {
                this.$notify({
                    text: "Missing Branch",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.phoneSchedules.some((b) => !b.daysSelected.length)) {
                this.$notify({
                    text: "Missing Days",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.phoneSchedules.some((b) => !b.timeFrom)) {
                this.$notify({
                    text: "Missing Time From",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.phoneSchedules.some((b) => !b.timeTo)) {
                this.$notify({
                    text: "Missing Time To",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            return true;
        },
        async savePhoneSchedules() {
            if (!this.validateSchedules()) return;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            try {
                this.processing = true;

                const list = this.phoneSchedules.map((schedule) => {
                    schedule.days = this.getNumberForDays(
                        schedule.daysSelected,
                    );
                    schedule.branch = schedule.branch
                        ? schedule.branch.join(",")
                        : this.branch;

                    return schedule;
                });

                await this.$http.post("api/campCalls/savePhoneSchedule", {
                    toUpdate: list || [],
                    toDelete: this.scheduleToDelete.map((schedule) => {
                        schedule.branch = schedule.branch
                            ? schedule.branch.join(",")
                            : this.branch;

                        return schedule;
                    }),
                });

                this.processing = false;
                this.scheduleToDelete = [];
                this.editingSchedule = false;
                this.loadPhoneSchedules();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        getBranch(branch) {
            return this.branch ? this.branch : branch;
        },
    },
};
</script>
<style>
.reminder .v-input__slot {
    margin-bottom: 0px !important;
}
.expired {
    color: #999;
}
</style>
